'use client';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { useRouter } from 'next/navigation';
import { useSession } from 'next-auth/react';

import { DashboardRefreshButton, DeleteModal, DeleteModalContextProvider } from '@ifa/ui/dashboard';
import { PatientDataModal } from '@ifa/ui/patientdataform';
import { DashboardTable } from '@ifa/ui/dashboard';

export default function Dashboard() {
    const router = useRouter();
    const session = useSession({
        required: true,
        onUnauthenticated() {
            console.warn(`User not signed in! Sending to signin page.`);
            router.push('/auth/required');
        },
    }); // TODO globally add session types to object
    const userData = {
        name: session.data?.user?.name ?? '',
        email: session.data?.user?.email ?? '',
        tcIds: session.data?.tcIds ?? [],
        cm: session.data?.cm ?? false,
    };
    return (
        <DeleteModalContextProvider>
            <Box>
                <Box sx={{ mt: 2, mb: 4 }}>
                    <Typography variant="h2">Form auto-population</Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        To populate a form automatically, click <strong>Create form request</strong>. Track the status
                        of your submission in the Submitted form requests section. Submitted forms are retained for
                        seven days from the submission date, after which they are permanently deleted.
                    </Typography>
                    <PatientDataModal userData={userData} />
                </Box>
                <Divider />
                <Box
                    sx={{
                        position: 'relative',
                        mt: 2,
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h2">Submitted form requests</Typography>
                        <DashboardRefreshButton />
                    </Box>
                    <DashboardTable />
                </Box>
            </Box>
            <DeleteModal />
        </DeleteModalContextProvider>
    );
}
